module.exports = __webpack_public_path__ + "img/logo-kbsim.6354092e.svg";